//roi
import request from '@/utils/request';
export function getCustomEevents(data) {
  return request({
    url: '/data/custom_events_data',
    method: 'get',
    params: data
  });
}